module.exports = __webpack_public_path__ + "media/halbschriftliches-Rechnen-Hunderterfeld.8aeb51bb.mp4";